module.exports = __webpack_public_path__ + "media/PinkShit.9d38d6e0.mp3";